// Auto-generated by scripts/generate-registry.mjs from packages/modules/bambu_ribbed_pumpkin_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const bambu_ribbed_pumpkin_lamp: ModuleSchema = {
  "id": "bambu_ribbed_pumpkin_lamp",
  "uniqueId": "B3D_7KFN8",
  "createdAt": "2026-10-02T14:21:58.713Z",
  "updatedAt": "2026-10-30T10:31:13.340Z",
  "label": "Pumpkin Shade",
  "description": "bambu_ribbed_pumpkin_lamp parametric 3D model",
  "category": "lamp_assembly",
  "tags": [
    "lamp",
    "bambu-led",
    "ribbed-pumpkin",
    "vase-mode"
  ],
  "sliders": [
    {
      "key": "shadeH",
      "label": "Shade Height",
      "min": 80,
      "max": 260,
      "step": 2,
      "default": 160,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeBotDia",
      "label": "Shade Base Diameter (Ø)",
      "min": 70,
      "max": 160,
      "step": 1,
      "default": 85,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeBellyDia",
      "label": "Pumpkin Belly Diameter (Ø)",
      "min": 80,
      "max": 220,
      "step": 1,
      "default": 150,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeTopDia",
      "label": "Top Mouth Diameter (Ø)",
      "min": 50,
      "max": 160,
      "step": 1,
      "default": 90,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "bellyPos",
      "label": "Pumpkin Belly Position",
      "min": 0.25,
      "max": 0.65,
      "step": 0.01,
      "default": 0.5,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "ribCount",
      "label": "Rib / Flute Count",
      "min": 16,
      "max": 96,
      "step": 2,
      "default": 48,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "ribDepth",
      "label": "Rib Flute Depth",
      "min": 0.5,
      "max": 6,
      "step": 0.25,
      "default": 2.5,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "baseDia",
      "label": "Lamp Base Diameter (Ø)",
      "min": 70,
      "max": 160,
      "step": 1,
      "default": 90,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1,
        2,
        3
      ]
    },
    {
      "key": "baseH",
      "label": "Lamp Base Height",
      "min": 20,
      "max": 60,
      "step": 1,
      "default": 25,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1,
        2,
        3
      ]
    },
    {
      "key": "baseFuzzy",
      "label": "Quick Fuzzy Toggle (0=Smooth, 1=Fuzzy)",
      "min": 0,
      "max": 1,
      "step": 1,
      "default": 0,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseTextureStyle",
      "label": "Base Texture Style (0=Trơn, 1=Sọc Cong Lõm, 2=Sọc Cong Lồi, 3=Sọc Nhọn Tam Giác, 4=Sọc Lồi/Lõm, 5=Fuzzy Skin)",
      "min": 0,
      "max": 5,
      "step": 1,
      "default": 0,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "ribbed_shade_body",
      "label": "Ribbed Pumpkin Lampshade (Vase Mode)",
      "default": "#f8fafc",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "bambu_led_base",
      "label": "Bambu LED Lamp Base Body",
      "default": "#d97706",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "led_retainer_cap",
      "label": "Bambu LED Module Retainer Cap",
      "default": "#0284c7",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "bambu_screws",
      "label": "4 M3 Mounting Screws",
      "default": "#94a3b8",
      "targetGroupIds": [
        3
      ]
    }
  ],
  "objects": [
    {
      "id": "ribbed_pumpkin_lamp_obj",
      "label": "Bambu Ribbed Pumpkin Lamp Assembly",
      "name": "Bambu Ribbed Pumpkin Lamp Assembly",
      "color": "#f8fafc",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "ribbed_shade_body",
          "label": "Ribbed Pumpkin Lampshade (Vase Mode)",
          "name": "Ribbed Pumpkin Lampshade (Vase Mode)",
          "groupId": 0,
          "colorKey": "ribbed_shade_body",
          "defaultColor": "#f8fafc",
          "assembled_z_offset": 0,
          "exploded_z_offset": 80,
          "export_stl": true
        },
        {
          "id": "bambu_led_base",
          "label": "Bambu LED Lamp Base Body",
          "name": "Bambu LED Lamp Base Body",
          "groupId": 1,
          "colorKey": "bambu_led_base",
          "defaultColor": "#d97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        },
        {
          "id": "led_retainer_cap",
          "label": "Bambu LED Module Retainer Cap",
          "name": "Bambu LED Module Retainer Cap",
          "groupId": 2,
          "colorKey": "led_retainer_cap",
          "defaultColor": "#0284c7",
          "assembled_z_offset": 0,
          "exploded_z_offset": 40,
          "export_stl": true
        },
        {
          "id": "bambu_screws",
          "label": "4 M3 Mounting Screws",
          "name": "4 M3 Mounting Screws",
          "groupId": 3,
          "colorKey": "bambu_screws",
          "defaultColor": "#94a3b8",
          "assembled_z_offset": 0,
          "exploded_z_offset": -30,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Full Lamp Assembly (All Parts)",
      "groupId": -1
    },
    {
      "id": "shade",
      "label": "Ribbed Pumpkin Lampshade Only",
      "groupId": 0
    },
    {
      "id": "base",
      "label": "Bambu LED Base Body Only",
      "groupId": 1
    },
    {
      "id": "cap",
      "label": "LED Retainer Cap Only",
      "groupId": 2
    },
    {
      "id": "screws",
      "label": "4 Mounting Screws Only",
      "groupId": 3
    }
  ]
};
